module.exports = __webpack_public_path__ + "img/ic_no_socialprofiles.1e857393.svg";